import { Controller } from "@hotwired/stimulus"
import { syncGateReason } from "../lib/gate_reason"

// Step 4 Continue gate: disabled until ≥1 selection in each of lead types, quality, languages, days (cap optional); OnboardingStepService#save_lead_preferences re-enforces server-side.
const FIELDS = [
  { name: "lead_preferences[interested_lead_types][]", label: "lead type" },
  { name: "lead_preferences[preferred_qualities][]",   label: "lead quality" },
  { name: "lead_preferences[preferred_languages][]",   label: "language" },
  { name: "default_days_per_week[]",                   label: "day" }
]

export default class extends Controller {
  static targets = ["continueBtn", "statusMessage"]

  connect() {
    this._onChange = () => this.refresh()
    this.element.addEventListener("change", this._onChange)
    this.refresh()
  }

  disconnect() {
    this.element.removeEventListener("change", this._onChange)
  }

  refresh() {
    const missing = FIELDS.filter(f => !this.atLeastOneCheckedFor(f.name)).map(f => f.label)
    const ready = missing.length === 0

    if (this.hasContinueBtnTarget) {
      syncGateReason(this.continueBtnTarget, { ready, reason: ready ? "" : this.missingMessage(missing) })
    }

    if (this.hasStatusMessageTarget) {
      if (ready) {
        this.statusMessageTarget.textContent = ""
        this.statusMessageTarget.classList.add("d-none")
      } else {
        this.statusMessageTarget.textContent = this.missingMessage(missing)
        this.statusMessageTarget.classList.remove("d-none")
      }
    }
  }

  atLeastOneCheckedFor(name) {
    return this.element.querySelectorAll(`input[name="${name}"]:checked`).length > 0
  }

  missingMessage(missing) {
    if (missing.length === 1) return `Select at least one ${missing[0]} to continue.`
    if (missing.length === 2) return `Select at least one ${missing[0]} and one ${missing[1]} to continue.`
    const head = missing.slice(0, -1).map(m => `one ${m}`).join(", ")
    const tail = `and one ${missing.at(-1)}`
    return `Select at least ${head}, ${tail} to continue.`
  }
}
